module.exports = __webpack_public_path__ + "e7c0103175f6f49a087c5f3c25a91424.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-12.jpg
// module id = 1152
// module chunks = 0